import { render, staticRenderFns } from "./ModalCostumers.vue?vue&type=template&id=0b2c77f3&scoped=true"
import script from "./ModalCostumers.vue?vue&type=script&lang=js"
export * from "./ModalCostumers.vue?vue&type=script&lang=js"
import style0 from "./ModalCostumers.vue?vue&type=style&index=0&id=0b2c77f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2c77f3",
  null
  
)

export default component.exports